import React from "react";
import { Box } from "@mui/material";

import i18n from "i18";
import config from "config";
import _helper from "actions/_helper";

import { ReactComponent as DeFlag } from "images/flags/de.svg";
import { ReactComponent as RuFlag } from "images/flags/ru.svg";
import { ReactComponent as UsFlag } from "images/flags/us.svg";
import { ReactComponent as FrFlag } from "images/flags/fr.svg";
import { ReactComponent as ItFlag } from "images/flags/it.svg";

const { langs } = config;

const allLangs = {
    en: {
        key: "en",
        name: "English",
        flag: UsFlag,
    },
    ru: {
        key: "ru",
        name: "Русский",
        flag: RuFlag,
    },
    de: {
        key: "de",
        name: "German",
        flag: DeFlag,
    },
    fr: {
        key: "fr",
        name: "Français",
        flag: FrFlag,
    },
    it: {
        key: "it",
        name: "Italiano",
        flag: ItFlag,
    },
};

const langsActive = (langs || ["en"])
    .map((key) => allLangs[key])
    .filter((it) => it?.key);

export default class LanguageSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openedButton: null,
        };

        this.onItemSelect = this.onItemSelect.bind(this);
        this.setOpened = this.setOpened.bind(this);
    }

    setOpened(openedButton) {
        this.setState({ openedButton });
    }

    flag(key) {
        const Flag = allLangs[key].flag;
        return <Flag height="16px" className="shad o5" />;
    }

    onItemSelect(key) {
        this.setOpened(null);
        _helper.changeLang(key);
    }

    render() {
        const currentKey = i18n.language;

        return (
            <Box className="languageSelect flex gap8 centerV">
                {langsActive.map(({ key, name }) => {
                    const selected = key === currentKey;

                    return (
                        <Box
                            key={key}
                            onClick={!selected ? () => this.onItemSelect(key) : null}
                            sx={{
                                cursor: !selected ? "pointer" : "default",
                                opacity: selected ? 0.5 : 1,
                            }}
                        >
                            <Box className="flex gap8 centerV">
                                {this.flag(key)}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        );
    }
}